/* eslint-disable camelcase */
import { takeEvery, call, put } from 'redux-saga/effects';
import actionKey from '../utils/action-key';
import request from '../api-utils/request';
import { FETCH_PROGRAM_MATCHES } from './programs';
import { showSnackbarAction } from './snackbar';


const CHANGE_FAVORITE = 'program/CHANGE_FAVORITE_CAREER';

export default (state = {}, action) => {
    switch (action.type) {
        case FETCH_PROGRAM_MATCHES:
            return {};
        case actionKey.success(FETCH_PROGRAM_MATCHES): {
            return action.payload.programs.reduce(
                (acc, { favoriteCareer, programId }) => {
                    acc[programId] = favoriteCareer;
                    return acc;
                },
                {},
            );
        }
        case CHANGE_FAVORITE: {
            return {
                ...state,
                [action.programId]: !state[action.programId],
            };
        }
        default:
            return state;
    }
};
export const changeFavoriteCareerAction = ({
    programId,
    userId,
    favorite,
    isFavoriteCareer,
}) => ({
    type: CHANGE_FAVORITE,
    programId,
    userId,
    favorite,
    isFavoriteCareer,
});

export function* rootSaga() {
    yield [
        takeEvery(CHANGE_FAVORITE, changeFavorite),
        takeEvery(actionKey.failure(CHANGE_FAVORITE), changeFavoriteError),
    ];
}


function* changeFavorite({ type, favorite, programId, userId, isFavoriteCareer }) {
    yield call(request, {
        url: '/api/programs/favorite-career',
        type,
        options: {
            body: {
              programId,
              userId,
              isFavoriteCareer,
            },
            method: favorite ? 'POST' : 'DELETE',
        },
    });
}


function* changeFavoriteError() {
    yield put(
        showSnackbarAction({
            message: 'Error saving favorite program, please refresh page',
            type: 'failure',
            timeout: 5000,
        }),
    );
}



// WEBPACK FOOTER //
// ./src/client/redux/favorite-programs-career.js